// Images pasted with Ctrl+V: staff copy screenshots out of the X-ray
// software.

// Screenshots all arrive as "image.png"; give each its own name.
export function namePasted(file, index = 0, now = new Date()) {
  const stamp = now
    .toTimeString()
    .slice(0, 8)
    .replace(/:/g, ".");
  const ext = file.type === "image/jpeg" ? "jpg" : "png";
  const suffix = index > 0 ? `-${index + 1}` : "";
  return new File([file], `ภาพหน้าจอ ${stamp}${suffix}.${ext}`, {
    type: file.type,
  });
}
